let counter = 0

/**
 * Locally unique id that works outside secure contexts (no `crypto.randomUUID`).
 * Not suitable for security purposes.
 */
export function createLocalId(prefix = 'id'): string {
  counter += 1
  return `${prefix}-${Date.now().toString(36)}-${counter.toString(36)}-${Math.random().toString(36).slice(2, 8)}`
}
